module.exports = __webpack_public_path__ + "img/cidis.ffa29914.png";